import React from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * Wraps children components with the IntlProvider only if one
 * doesn't already exist in the component ancestry.
 * @param {ReactNode} props.children - child components to be wrapped.
 * @returns {ReactNode} - conditionally wrapped child components.
 */
function LocalizedWrapper({ children }) {
  try {
    useIntl(); // if not already wrapped, this will throw an error executing the catch block

    return children;
  } catch {
    return <IntlProvider locale='en'>{children}</IntlProvider>;
  }
}

LocalizedWrapper.propTypes = { children: PropTypes.node.isRequired };

export default LocalizedWrapper;
